import { addLocaleData } from 'react-intl';
import enLang from './entries/en-US';
import deLang from './entries/de-DE';
import frLang from './entries/fr-FR';
import jaLang from './entries/ja-JP';
import featureMessages from './featureMessages';

// BuildConfig.FEATURES overrides win over both the base locale and the customer variant file.
const withFeatureMessages = lang => ({
  ...lang,
  messages: { ...lang.messages, ...featureMessages(lang.locale) },
});

const AppLocale = {
  en: withFeatureMessages(enLang),
  de: withFeatureMessages(deLang),
  fr: withFeatureMessages(frLang),
  ja: withFeatureMessages(jaLang),
};

addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.de.data);
addLocaleData(AppLocale.fr.data);
addLocaleData(AppLocale.ja.data);

export default AppLocale;
